import { useEffect, useRef } from "react";
import Lenis from "lenis";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Tutors from "@/components/Tutors";
import Subjects from "@/components/Subjects";
import Method from "@/components/Method";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Admin from "@/components/Admin";
import AuthPage from "@/components/Auth";

function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App" data-testid="app-root">
            <div className="noise-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Tutors />
                <Subjects />
                <Method />
                <Pricing />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

const AuthCallback = () => {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
        axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`, { session_id: sessionId })
            .then((res) => {
                localStorage.setItem("site_token", res.data.token);
                localStorage.setItem("site_name", res.data.name);
                navigate("/", { replace: true });
            })
            .catch(() => navigate("/accedi", { replace: true }));
    }, [navigate]);

    return (
        <div className="min-h-screen bg-[#020617] flex items-center justify-center">
            <Loader2 size={36} className="animate-spin text-sky-400" />
        </div>
    );
};

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/accedi" element={<AuthPage />} />
            <Route path="/admin" element={<Admin />} />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Toaster theme="dark" position="bottom-right" />
            <AppRouter />
        </BrowserRouter>
    );
}

export default App;
